import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import './scoreboard.css'
import MobileLiveStreamTab from './MobileLiveStreamTab';
import StringToHtml from '../../StringToHtml';

function Scoreboard({scoreboardData, receivedBetlistData,eventId,url,scoreUrl}) {
  const spId = scoreboardData?.sportId;
  const evId = scoreboardData?.eventId;
  const [scoresUrl, setScoreUrl] = useState("");
  const [tvUrl, setTvUrl] = useState("");
  const [isApiCall, setAPICall] = useState(false);

  const [eventName, setEventName] = useState("");
  const [competitionName, setCompetitionName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [matchStatus, setMatchStatus] = useState('');
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
    callAPI();
    }
  
    
  },[scoreboardData]);


  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
  
    useLayoutEffect(() => {
      const updateWidth = () => setWidth(window.innerWidth);
      window.addEventListener("resize", updateWidth);
      return () => window.removeEventListener("resize", updateWidth);
    }, []);
  
    return width;
  };

  const callAPI =()=>{
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    fetch(`${process.env.REACT_APP_BASE_URL}/getmatchdata?matchId=${eventId}`, requestOptions)
    .then(async (response) => {
      let paresData = await response.json();
      setCompetitionName(paresData.match.competitionName);
      setEventName(paresData.match.eventName);
      setEventDate(paresData.match.openDate);
      setMatchStatus(paresData.match.status);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const callScoreAPI = async (scoreboardData)=>{
    // console.log(scoreboardData,"............scoreboardData");
    
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

        const raw = JSON.stringify({
          "whiteLabelName": window.location.hostname,
          "eventId":scoreboardData?.eventId ? scoreboardData?.eventId : evId,
          "sportId":scoreboardData?.sportId ? scoreboardData?.sportId : spId
        });

        const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
        };
    
    fetch(`${process.env.REACT_APP_BASE_URL}/getScoreCard`, requestOptions)
    .then(async (response) => {
      let paresData = await response.json();
      setScoreUrl(paresData.scorecard);
      setTvUrl(paresData.livestreme);
      setAPICall(true);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const getIframe = (url) => {
    // console.log(url,"getIframegetIframegetIframe");
    
      return <StringToHtml htmlString={url}  />
  }
  const width = useWindowWidth();

  return (
    <div className='live-score'>
      <div className="heading">
        <div className="heading-text sport-name"><span className='series-name'>{competitionName}</span> <span className='seprator'>/</span> <strong>{eventName}</strong></div>
        <div className="heading-text time"><i className="fa-regular fa-clock"></i> {eventDate && (
          <>
            {new Date(eventDate).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
            {" at "}
            {new Date(eventDate).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              hour12: false,
            })}
          </>
        )}</div></div>
      {<div className='scoreboard'>
        {getIframe(scoreUrl)}
      </div> }
      {<MobileLiveStreamTab matchStatus={matchStatus} spId={spId} evId={evId} receivedBetlistData= {receivedBetlistData} url={scoreUrl} tvUrl={url} width={width} />}
    </div>
  )
}

export default Scoreboard